import { Box, Chip, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';

function Row(props) {
  const { row } = props;
  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>{row.title}</TableCell>
        <TableCell align="left">{row?.modified_history?.changed_on}</TableCell>
        <TableCell align="left">{row?.modified_history?.payout}</TableCell>
        <TableCell align="left">{row?.modified_history?.updated_payout}</TableCell>
        <TableCell align="left">{row?.modified_history?.publisher}</TableCell>
        <TableCell align="left">{row?.modified_history?.updated_publisher}</TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function PayoutsTable({
  
  details,
  
}) {
  // const [details, setDetails] = React.useState([]);
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table" stickyHeader={true}>
        <TableHead>
          <TableRow>
            <TableCell align="left" sx={{fontSize:'.9rem'}}><b>Product</b></TableCell>
            <TableCell align="left" sx={{fontSize:'.9rem'}}><b>Updated On</b></TableCell>
            <TableCell align="left" sx={{fontSize:'.9rem'}}><b>Status</b></TableCell>
            <TableCell align="left" sx={{fontSize:'.9rem'}}><b>Payout</b></TableCell>
            <TableCell align="left" sx={{fontSize:'.9rem'}}><b>Publisher</b></TableCell>
            <TableCell align="left" sx={{fontSize:'.9rem'}}><b>Publisher Amount</b></TableCell>
            <TableCell align="left" sx={{fontSize:'.9rem'}}><b>Strategy</b></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {details && details.length
            ? (
            details.map(product=>{
              if(typeof product?.modified_history === 'string'){
              product['modified_history'] = JSON.parse(product.modified_history)
              }
            return (
            <TableRow key={product.title} sx={{outline:'.3px #aaa solid'}}>
                  <TableCell sx={{ maxWidth: '150px', minWidth: '165px' }}>
                    <Typography
                      sx={{
                        fontSize: '15px',
                        fontWeight: '500',
                        
                      }}
                    >
                    <Chip sx={{my:1}} label={product?.status} variant='outlined'></Chip>
                    <br/>
                      {product?.title}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ maxWidth: '120px', minWidth: '115px' }}>
                    <Typography
                      sx={{
                        fontSize: '15px',
                        fontWeight: '500',
                      }}
                    >
                      {product?.modified_history.changed_on}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ maxWidth: '120px', minWidth: '115px' }}>
                    <Typography
                      sx={{
                        fontSize: '15px',
                        fontWeight: '500',
                      }}
                    >
                      {product?.modified_history?.status || 'N/A'}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Box>
                      <Typography variant='subtitle2' fontWeight={600}>
                      updated:{' '}{product.modified_history?.updated_payout || '-'}
                      </Typography>
                      <Typography variant="subtitle2">
                        Old: {' '} {product.modified_history?.payout  || '-'}
                      </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Box>
                      <Typography variant='subtitle2' fontWeight={600}>
                      updated:{' '}{product.modified_history?.updated_publisher  || '-'}
                      </Typography>
                      <Typography variant="subtitle2">
                        Old: {' '} {product.modified_history?.publisher  || '-'}
                      </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Box>
                      <Typography variant='subtitle2' fontWeight={600}>
                      updated:{' '}{product.modified_history?.updated_publisher_amount || '-'}
                      </Typography>
                      <Typography variant="subtitle2">
                        Old: {' '} {product.modified_history?.publisher_amount || '-'}
                      </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Box>
                      <Typography variant='subtitle2' fontWeight={600}>
                      updated:{' '}{product.modified_history?.updated_earntype || '-'}
                      </Typography>
                      <Typography variant="subtitle2">
                        Old: {' '} {product.modified_history?.earntype || '-'}
                      </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  </TableRow>)
}))
            : ''}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
